import { useFormik } from "formik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

// observable store
const artworkFilterStore = makeObservable({});
const artworkNavigationStore = createSearchResultNavigationStore();

const useArtworkFilters = () => {
  const formik = useFormik({
    initialValues: {
      limit: 50,
      medium: { operator: "like" },
      offset: 0,
      tab: "instance",
      _artworkCategory: { id: { operator: "in" } },
      _edition: { year: { operator: "eq" } },
    },
  });

  const filterKeys = ["tab"];

  const skipKeys = ["limit", "offset"];

  useEffect(() => {
    // convert formik values to filter and update store
    artworkFilterStore.set(
      convertToFilter({ values: formik.values, filterKeys, skipKeys }),
    );
  }, [formik.values]);

  return {
    formik,
  };
};

export { artworkFilterStore, artworkNavigationStore, useArtworkFilters };
